import { useState, useEffect } from 'react'
import {
    getConversationHistory,
    getConversationHistoryFromGenerative,
    getUserInfoFromBdd,
    getSessionInfo,
    RetrieveSession
} from "@/lib/api-chatbot-client";


export function useSessionChatbot(questions) {
    const [sessionId, setSessionId] = useState(null)
    const [userId, setUserId] = useState(null)
    const [messages, setMessages] = useState([
        { id: 1, text: "Bonjour comment puis-je vous aider ?", sender: "bot" }
    ])
    const [userInfo, setUserInfo] = useState({
        nom: "",
        prenom: "",
        age: "",
        sexe: "",
        taille: "",
        poids: "",
        objectif: ""
    })
    const [currentStep, setCurrentStep] = useState(0)

    useEffect(() => {
        const initSession = async () => {
            try {
                console.log("🚀 initSession lancée")

                // Récupérer le sessionId du localStorage s'il existe
                const savedSessionId = localStorage.getItem('sessionId')
                console.log("📦 SessionId du localStorage:", savedSessionId)

                // Envoyer le sessionId au backend (ou null si premier appel)
                const res = await RetrieveSession(savedSessionId)
                console.log("🔍 RetrieveSession réponse:", res)

                if (res?.sessionId) {
                    const sId = res.sessionId
                    const uId = res.userId
                    console.log("✅ Session ID:", sId)
                    console.log("✅ User ID:", uId)

                    // Sauvegarder le sessionId dans localStorage
                    localStorage.setItem('sessionId', sId)
                    console.log("💾 SessionId sauvegardé:", sId)

                    setSessionId(sId)
                    setUserId(uId)

                    // Récupérer les infos complets de la session
                    try {
                        const sessionInfo = await getSessionInfo(sId)
                        console.log("🔍 Session info:", sessionInfo)
                        const userIdFromSession = sessionInfo.user_id
                        console.log("✅ User ID from session:", userIdFromSession)

                        // 🔥 IMPORTANT: Mettre à jour le userId avec l'integer de la BDD
                        if (userIdFromSession) {
                            setUserId(userIdFromSession)
                        }

                        // Récupérer aussi l'historique générative (mémoire LLM)
                        const generativeHistory = await getConversationHistoryFromGenerative(sId)

                        console.log("🔍 Historique generative:", generativeHistory)

                        // Récupérer l'historique
                        const history = await getConversationHistory(sId)
                        console.log("🔍 Historique reçu:", history)

                        if (history && history.length > 0) {
                            console.log("✅ Historique trouvé! Messages:", history.length)
                            const formatted = history.map((msg) => ({
                                id: msg.id,
                                text: msg.message,
                                sender: msg.sender,
                                timestamp: ""
                            }))

                            setMessages([
                                { id: 1, text: "Bonjour comment puis-je vous aider ?", sender: "bot" },
                                ...formatted
                            ])

                            setCurrentStep(questions.length)
                            console.log("✅ currentStep set à:", questions.length)

                            // Récupérer les infos utilisateur
                            if (userIdFromSession) {
                                try {
                                    const dbInfo = await getUserInfoFromBdd(userIdFromSession)
                                    console.log("🔍 Infos BDD:", dbInfo)
                                    if (dbInfo && !dbInfo.error) {
                                        setUserInfo(dbInfo)
                                        console.log("✅ Infos récupérées de la BDD:", dbInfo)
                                    }
                                } catch (err) {
                                    console.error('❌ Erreur récupération infos BDD:', err)
                                }
                            }
                        } else {
                            console.log("⚠️ Pas d'historique trouvé")
                        }
                    } catch (err) {
                        console.error("❌ Erreur récupération infos session:", err)
                    }
                } else {
                    console.log("⚠️ Pas de sessionId reçu")
                }
            } catch (err) {
                console.error("❌ Erreur session :", err)
            }
        }

        initSession()
    }, [])

    return {
        sessionId,
        setSessionId,
        userId,
        setUserId,
        messages,
        setMessages,
        userInfo,
        setUserInfo,
        currentStep,
        setCurrentStep
    }
}